import { useQuery } from '@apollo/client';
import {
  CasesCredentialVerificationV1IndexContainerStaffUserCurrentDocument,
  CasesCredentialVerificationV1IndexContainerStaffUserCurrentFieldsFragment
} from '../../../../../generated';
import { useOid } from '../../../../../hooks/useOid';
import { ComponentQueryLoader } from '../../../../shared/component-query-loader';
import { CredentialVerification } from './index';
import { getStaffUserCurrentQueryOptionsWithOidAndCacheEnabled } from '../../../../shared/utils/queryOptions';

interface CaseDetailsContainerProps {
  isApplicantSection?: boolean;
}

export const CaseDetailsContainer: React.FC<CaseDetailsContainerProps> = (props) => {
  const oid = useOid();
  const staffUserCurrentQueryOptions = getStaffUserCurrentQueryOptionsWithOidAndCacheEnabled(oid);

  const {
    data: staffUserData,
    loading: staffUserLoading,
    error: staffUserError
  } = useQuery(CasesCredentialVerificationV1IndexContainerStaffUserCurrentDocument, staffUserCurrentQueryOptions);

  return (
    <ComponentQueryLoader
      error={staffUserError}
      loading={staffUserLoading}
      hasData={staffUserData?.staffUserCurrent}
      hasDataComponent={
        <CredentialVerification
          staffUserData={staffUserData?.staffUserCurrent as CasesCredentialVerificationV1IndexContainerStaffUserCurrentFieldsFragment}
          isApplicantSection={props.isApplicantSection}
        />
      }
    />
  );
};
